"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("@components/hyperlinks/hyperlinks-modal-controller");
var angular_1 = __importDefault(require("angular"));
var lodash_1 = __importDefault(require("lodash"));
var hyperlinks_modal_html_1 = __importDefault(require("./hyperlinks-modal.html"));
(function (module) {
    'use strict';
    module.factory('prHyperlinksModal', [
        '$rootScope',
        'qstrap.modal',
        // @ts-ignore
        // @ts-ignore
        function ($rootScope, modal) {
            function open(extendScope) {
                var $scope = $rootScope.$new();
                lodash_1.default.assign($scope, extendScope);
                modal({
                    templateUrl: hyperlinks_modal_html_1.default,
                    show: true,
                    scope: $scope,
                    controller: 'prHyperlinksModalController'
                });
            }
            return {
                open: open
            };
        }
    ]);
})(angular_1.default.module('qualtrics.pr'));
